import React from 'react';
import { Route } from 'react-router';
import SettingsPage from '../../pages/settings/SettingsPage';
import ProfilePage from '../../pages/user/profile/ProfilePage';
import ItemReportPdf from '../Pdf/item/ItemReportPdf';
import WrappedAddUser from '../../pages/user/AddUser';
import WiredPermissionPage from '../../pages/user/PermissionPage';
import UserList from '../../pages/user/UserList';
import UpdateUser from '../../pages/user/UpdateUser';
import UserGroupsPage from '../../pages/user/UserGroupsPage';
import ActivityList from '../../pages/user/ActivityList';
import NotFound from '../NotFound';
import PoiList from '../../pages/appCms/poi/PoiList';
import AddPoi from '../../pages/appCms/poi/AddPoi';
import UpdatePoi from '../../pages/appCms/poi/UpdatePoi';
import PoiGroupList from '../../pages/appCms/poiGroup/PoiGroupList';
import AddPoiGroup from '../../pages/appCms/poiGroup/AddPoiGroup';
import UpdatePoiGroup from '../../pages/appCms/poiGroup/UpdatePoiGroup';
import NewsList from '../../pages/appCms/news/NewsList';
import AddNews from '../../pages/appCms/news/AddNews';
import UpdateNews from '../../pages/appCms/news/UpdateNews';
import AppSettings from '../../pages/appCms/appSettings/AppSettings';
import BeaconList from '../../pages/appCms/beacon/BeaconList';
import AssignBeacon from '../../pages/appCms/beacon/AssignBeacon';
import FBQPolicy from '../../pages/policy/fbq';
import SaveObject from '../../nextgen/pages/object-overview/SaveObject';
import ShowObjects from '../../nextgen/pages/object-overview/ShowObjects';
import Dropdowns from '../../nextgen/pages/dropdowns/Dropdowns';
import SaveCondition from '../../nextgen/pages/condition/SaveCondition';
import ShowConditions from '../../nextgen/pages/condition/ShowConditions';
import ShowTreatments from '../../nextgen/pages/treatment/ShowTreatments';
import SaveTreatment from '../../nextgen/pages/treatment/SaveTreatment';
import ShowCuratorialForm from '../../nextgen/pages/curatorial-fom/ShowCuratorialForm';
import SaveCuratorialForm from '../../nextgen/pages/curatorial-fom/SaveCuratorialForm';
import ShowTechnicalForm from '../../nextgen/pages/technical-form/ShowTechnicalForm';
import SaveTechnicalForm from '../../nextgen/pages/technical-form/SaveTechnicalForm';
import ShowMovements from '../../nextgen/pages/movement/ShowMovements';
import SaveMovement from '../../nextgen/pages/movement/SaveMovement';
import ShowInsurances from '../../nextgen/pages/insurance/ShowInsurances';
import SaveInsurance from '../../nextgen/pages/insurance/SaveInsurance';
import Languages from '../../pages/appCms/languages/Languages';
import Dashboard from '../../nextgen/pages/dashboard/dashboard';
import ScanTable from '../../pages/appCms/beacon/ScanTable';

const routes = [
  {
    path: '/',
    component: Dashboard,
    key: '/',
  },
  {
    path: '/dashboard',
    component: Dashboard,
    key: 'dashboard',
  },
  {
    path: '/settings',
    component: SettingsPage,
    key: 'settings',
  },
  {
    path: '/profile',
    component: ProfilePage,
    key: 'profile',
  },
  {
    path: '/pdf',
    component: ItemReportPdf,
    key: 'pdf',
  },
  {
    path: '/permissions',
    component: WiredPermissionPage,
    key: 'permissions',
  },
  {
    path: '/add-user',
    component: WrappedAddUser,
    key: '/add-user',
  },
  {
    path: '/user-list',
    component: UserList,
    key: 'user-list',
  },
  {
    path: '/updateUser/:id',
    component: UpdateUser,
    key: 'updateUser',
  },
  {
    path: '/user-groups',
    component: UserGroupsPage,
    key: 'userGroupsPage',
  },
  {
    path: '/activity-log',
    component: ActivityList,
    key: 'activity-log',
  },
  {
    path: '/404',
    component: NotFound,
    key: 'notFound',
  },
  {
    path: '/pois',
    component: PoiList,
    key: 'pois',
  },

  {
    path: '/add-poi',
    component: AddPoi,
    key: 'add-poi',
  },
  {
    path: '/updatePoi/:id',
    component: UpdatePoi,
    key: 'updatePoi',
  },

  {
    path: '/poi-groups',
    component: PoiGroupList,
    key: 'poi-groups',
  },

  {
    path: '/add-poi-group',
    component: AddPoiGroup,
    key: 'add-poi-group',
  },
  {
    path: '/updatePoiGroup/:id',
    component: UpdatePoiGroup,
    key: 'updatePoiGroup',
  },

  {
    path: '/beacons',
    component: BeaconList,
    key: 'beacons',
  },
  {
    path: '/beacon-scans',
    component: ScanTable,
    key: 'beacon-scans',
  },

  {
    path: '/assignBeacon/:uniqueId/:id',
    component: AssignBeacon,
    key: 'assignBeacon',
  },
  {
    path: '/news',
    component: NewsList,
    key: 'news',
  },
  {
    path: '/add-news',
    component: AddNews,
    key: 'add-news',
  },
  {
    path: '/updateNews/:id',
    component: UpdateNews,
    key: 'updateNews',
  },
  {
    path: '/app-settings',
    component: AppSettings,
    key: 'app-settings',
  },
  {
    path: 'policy',
    component: FBQPolicy,
    key: 'policy',
  },
  {
    path: '/objects',
    component: ShowObjects,
    key: 'objects',
  },
  {
    path: '/save-object/:id',
    component: SaveObject,
    key: 'update-object',
  },
  {
    path: '/add-object',
    component: SaveObject,
    key: 'create-object',
  },
  {
    path: '/dropdowns',
    component: Dropdowns,
    key: 'dropdowns',
  },
  {
    path: '/conditions',
    component: ShowConditions,
    key: 'conditions',
  },
  {
    path: '/save-condition/:id',
    component: SaveCondition,
    key: 'update-condition',
  },
  {
    path: '/add-condition',
    component: SaveCondition,
    key: 'create-condition',
  },
  {
    path: '/treatments',
    component: ShowTreatments,
    key: 'treatments',
  },
  {
    path: '/save-treatment/:id',
    component: SaveTreatment,
    key: 'update-treatment',
  },
  {
    path: '/add-treatment',
    component: SaveTreatment,
    key: 'create-treatment',
  },
  {
    path: '/curatorial-forms',
    component: ShowCuratorialForm,
    key: 'curatorial-forms',
  },
  {
    path: '/save-curatorial-form/:id',
    component: SaveCuratorialForm,
    key: 'update-curatorial-form',
  },
  {
    path: '/add-curatorial-form',
    component: SaveCuratorialForm,
    key: 'create-curatorial-form',
  },
  {
    path: '/technical-forms',
    component: ShowTechnicalForm,
    key: 'technical-form',
  },
  {
    path: '/save-technical-form/:id',
    component: SaveTechnicalForm,
    key: 'update-technical-form',
  },
  {
    path: '/add-technical-form',
    component: SaveTechnicalForm,
    key: 'create-technical-form',
  },
  {
    path: '/movements',
    component: ShowMovements,
    key: 'movements',
  },
  {
    path: '/save-movement/:id',
    component: SaveMovement,
    key: 'update-movement',
  },
  {
    path: '/add-movement',
    component: SaveMovement,
    key: 'create-movement',
  },
  {
    path: '/insurances',
    component: ShowInsurances,
    key: 'insurances',
  },
  {
    path: '/save-insurance/:id',
    component: SaveInsurance,
    key: 'update-insurance',
  },
  {
    path: '/add-insurance',
    component: SaveInsurance,
    key: 'create-insurance',
  },
  {
    path: '/languages',
    component: Languages,
    key: 'languages',
  },
];

function CustomRouter() {
  return routes.map(item => {
    if (item.path.split('/').length === 2) {
      return (
        <Route
          exact
          path={item.path}
          component={item.component}
          key={item.key}
        />
      );
    }
    return <Route path={item.path} component={item.component} key={item.key}/>;
  });
}

export default CustomRouter;
